import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Layout1 from '@/layouts/Layout1'
import { Box, Tab, Tabs, tabsClasses } from '@mui/material'

import TabBirthdayMessage from './components/TabBirthdayMessage'
import TabConnection from './components/TabConnection'
import TabManagement from './components/TabManagement'
import TabTurnsHistory from './components/TabTurnsHistory'

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ mt: 0.5 }}>{children}</Box>}
    </div>
  )
}

const WAPP_TABS = {
  CONNECTION: 0,
  REMINDERS: 1,
  HISTORY: 2,
  BIRTHDAY_MESSAGE: 3,
}

const WappPage = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [value, setValue] = useState(WAPP_TABS.CONNECTION)

  const status = useSelector((state) => state?.wapp?.status)

  const isConnected = status?.status === 'connected'
  const isWappUnavailable = status === 'WAPP_SERVICE_UNAVAILABLE'
  const shouldDisableManagementTab = status?.status !== 'connected' && !isWappUnavailable

  useEffect(() => {
    if (!isConnected) {
      setValue(WAPP_TABS.CONNECTION)
      return
    }
    setValue(WAPP_TABS.REMINDERS)
  }, [isConnected])

  const handleTabChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <Layout1 navbar isLoading={isLoading}>
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            variant="scrollable"
            scrollButtons="auto"
            aria-label="Módulo wapp"
            value={value}
            onChange={handleTabChange}
            sx={{
              '& .MuiTab-root.Mui-selected': {
                color: '#4C5EFE',
              },
              [`& .${tabsClasses.scrollButtons}`]: {
                '&.Mui-disabled': { opacity: 0.3 },
              },
            }}
          >
            <Tab label="Conexión" value={WAPP_TABS.CONNECTION} />

            <Tab label="Recordatorios" value={WAPP_TABS.REMINDERS} disabled={shouldDisableManagementTab} />

            <Tab label="Historial" value={WAPP_TABS.HISTORY} />

            <Tab label="Mensaje de cumpleaños" value={WAPP_TABS.BIRTHDAY_MESSAGE} />
          </Tabs>
        </Box>

        <TabPanel value={value} index={WAPP_TABS.CONNECTION}>
          <TabConnection isLoading={isLoading} setIsLoading={setIsLoading} handleTabChange={handleTabChange} />
        </TabPanel>

        <TabPanel value={value} index={WAPP_TABS.REMINDERS}>
          <TabManagement />
        </TabPanel>

        <TabPanel value={value} index={WAPP_TABS.HISTORY}>
          <TabTurnsHistory />
        </TabPanel>

        <TabPanel value={value} index={WAPP_TABS.BIRTHDAY_MESSAGE}>
          <TabBirthdayMessage />
        </TabPanel>
      </Box>
    </Layout1>
  )
}

export default WappPage
